import React from 'react';

import './EmptyState.scss';

export default function EmptyState() {
  return (
    <>
      <div className="onboarding-workspaces-preview-content-title-empty-line" />
      <br />
      <div className="onboarding-workspaces-preview-content-first-emptyline" />
      <div className="onboarding-workspaces-preview-content-second-emptyline" />
      <div className="onboarding-workspaces-preview-content-third-emptyline" />
    </>
  );
}
